import axios from 'axios'

import {
  GET_NUMBER_OF_RECEIPTS_REQUEST,
  GET_NUMBER_OF_RECEIPTS_SUCCESS,
  GET_NUMBER_OF_RECEIPTS_FAIL,
  GET_RECEIPT_METAINFO_REQUEST,
  GET_RECEIPT_METAINFO_SUCCESS,
  GET_RECEIPT_METAINFO_FAIL,
  GET_RECEIPT_CATEGORY_REQUEST,
  GET_RECEIPT_CATEGORY_SUCCESS,
  GET_RECEIPT_CATEGORY_FAIL,
  GET_OWNER_UNIQUE_CUSTOMERS_REQUEST,
  GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS,
  GET_OWNER_UNIQUE_CUSTOMERS_FAIL,
  GET_OWNER_DASHBOARD_STATS_REQUEST,
  GET_OWNER_DASHBOARD_STATS_SUCCESS,
  GET_OWNER_DASHBOARD_STATS_FAIL
} from '../constants/dashboardConstants.js'

import { API_URL } from '../apiUrl.js'
import { authHeader } from '../utils/authHeader.js'

// Get number of receipts for user dashboard
export const getnumofRcpts = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_NUMBER_OF_RECEIPTS_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    const { data } = await axios.get(`${API_URL}/receipts/count`, config)

    dispatch({ type: GET_NUMBER_OF_RECEIPTS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_NUMBER_OF_RECEIPTS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const getnumofRcptsOwner = (cid) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_NUMBER_OF_RECEIPTS_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    const { data } = await axios.get(
      `${API_URL}/owners/rcptcount?cid=${cid}`,
      config
    )

    dispatch({ type: GET_NUMBER_OF_RECEIPTS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_NUMBER_OF_RECEIPTS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const getOwnerUniqueCustomers = (cid) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_OWNER_UNIQUE_CUSTOMERS_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    const { data } = await axios.get(
      `${API_URL}/owners/uniquecustomers?cid=${cid}`,
      config
    )

    dispatch({ type: GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_OWNER_UNIQUE_CUSTOMERS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const getOwnerDashboardStats = (cid) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_OWNER_DASHBOARD_STATS_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    const { data } = await axios.get(
      `${API_URL}/owners/dashboardstats?cid=${cid}`,
      config
    )

    dispatch({ type: GET_OWNER_DASHBOARD_STATS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_OWNER_DASHBOARD_STATS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Get metadata for user dashboard
export const getReceiptMetainfo = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_RECEIPT_METAINFO_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    const { data } = await axios.get(
      `${API_URL}/receipts/receiptmeta/${id}`,
      config
    )

    dispatch({ type: GET_RECEIPT_METAINFO_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_RECEIPT_METAINFO_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Get receipt category data for user dashboard
export const getReceiptCategory = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_RECEIPT_CATEGORY_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    const { data } = await axios.get(
      `${API_URL}/receipts/rcptcategory/${id}`,
      config
    )

    dispatch({ type: GET_RECEIPT_CATEGORY_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: GET_RECEIPT_CATEGORY_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}
